import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    impressionName: String,
    clickName: String,
    params: Object
  }

  connect() {
    if (this.hasImpressionNameValue) this.#push(this.impressionNameValue)
  }

  fireClick() {
    if (this.hasClickNameValue) this.#push(this.clickNameValue)
  }

  #push(eventName) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName, ...this.paramsValue })
  }
}
